<template>
  <b-notification :has-icon="true" icon="file" :closable="false">
    {{ $t('compCarbonFormsPurchasesHelpFileFormat.info-1') }}
    <a class="link" href="/static/carbon/purchasesTemplate.tsv" download>{{
      $t('compCarbonFormsPurchasesHelpFileFormat.info-3')
    }}</a>
    {{ $t('compCarbonFormsPurchasesHelpFileFormat.info-3a') }}
    <a class="link" href="/static/carbon/purchasesTemplate.csv" download>{{
      $t('compCarbonFormsPurchasesHelpFileFormat.info-3b')
    }}</a
    >).
    {{ $t('compCarbonFormsPurchasesHelpFileFormat.info-4') }}
    <br /><br />
    <ul style="list-style-type: square; margin-left: 25px">
      <li v-html="$t('compCarbonFormsPurchasesHelpFileFormat.info-5')"></li>
      <li v-html="$t('compCarbonFormsPurchasesHelpFileFormat.info-6')"></li>
      <li v-html="$t('compCarbonFormsPurchasesHelpFileFormat.info-8')"></li>
      <li v-html="$t('compCarbonFormsPurchasesHelpFileFormat.info-9')"></li>
      <li v-html="$t('compCarbonFormsPurchasesHelpFileFormat.info-7')"></li>
    </ul>
  </b-notification>
</template>

<script>
export default {
  name: 'HelpFileFormat'
}
</script>
